// test598
(598 && 0);
